import { render } from "./RescuePassDialogLogin.vue?vue&type=template&id=04fbc690&scoped=true"
import script from "./RescuePassDialogLogin.vue?vue&type=script&lang=js"
export * from "./RescuePassDialogLogin.vue?vue&type=script&lang=js"

import "./RescuePassDialogLogin.vue?vue&type=style&index=0&id=04fbc690&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fbc690"]])

export default __exports__